import { useBreakpoint } from "@povio/ui";
import type { ReactElement } from "react";
import type { MenuItemProps, PopoverProps } from "react-aria-components";

import { MenuDesktop } from "@/components/ui/Menu/MenuDesktop";
import { MenuMobile } from "@/components/ui/Menu/MenuMobile";

export interface MenuItem extends Omit<MenuItemProps, "aria-label" | "textValue" | "children"> {
  label: string;
  content?: string | ReactElement;
  children?: MenuItem[];
}

export interface MenuProps {
  breakpoint?: "md" | "lg" | "xl";
  trigger: ReactElement;
  items: MenuItem[];
  triggerClassName?: string;
  popoverProps?: PopoverProps;
  id?: string;
  isOpen?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
}
export const Menu = (props: MenuProps) => {
  const isDesktop = useBreakpoint(props.breakpoint || "md");

  if (isDesktop) {
    return <MenuDesktop {...props} />;
  }

  return <MenuMobile {...props} />;
};
